module.exports = __webpack_public_path__ + "img/cloud-drizzle.8c26f7e6.svg";